'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lib = require('helpers/lib');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * PropType @cat and @sub:
 * {
 *   key: ...,
 *   type: ...,
 *   data: [
 *     {label: ..., value:...},
 *     ...,
 *     {...}
 *   ]
 * }
 * PropType @active and @subActive:
 * ["01", "02",...]
 */
var SelectCategory = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SelectCategory, _Component);

  function SelectCategory() {
    (0, _classCallCheck3.default)(this, SelectCategory);
    return (0, _possibleConstructorReturn3.default)(this, (SelectCategory.__proto__ || (0, _getPrototypeOf2.default)(SelectCategory)).apply(this, arguments));
  }

  (0, _createClass3.default)(SelectCategory, [{
    key: 'classCat',
    value: function classCat(code) {
      var styles = require('./CommonUI.scss');
      switch (code) {
        case '01':
          return styles.spa;
        case '02':
          return styles.hair;
        case '03':
          return styles.cosmetic;
        case '04':
          return styles.clinic;
        case '05':
          return styles.fitness;
        case '06':
          return styles.tatoo;
        case '07':
          return styles.homeService;
        case 'M1':
          return styles.salonMiMong;
        case 'M2':
          return styles.spaChamDa;
        case 'M3':
          return styles.massageGoiDau;
        case 'M4':
          return styles.thamMyNhaKhoa;
        case 'M5':
          return styles.salonTocMakeUp;
        case 'M6':
          return styles.hoiThao;
        case 'M7':
          return styles.khoaHoc;
        default:
          break;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./CommonUI.scss');
      var _props = this.props,
          _props$cat = _props.cat,
          key = _props$cat.key,
          data = _props$cat.data,
          dataSub = _props.sub.data,
          active = _props.active,
          subActive = _props.subActive;

      var subs = [];
      if (dataSub && dataSub.length) {
        dataSub.map(function (v) {
          if (subActive.indexOf(String(v.value)) !== -1) {
            subs.push(v.label);
          }
        });
      }
      var dataWithoutXamHinh = data.filter(function (v) {
        return v.value !== '06';
      });
      return _react2.default.createElement(
        'div',
        { className: styles.selectList },
        dataWithoutXamHinh.map(function (item, i) {
          return _react2.default.createElement(
            'div',
            {
              key: 'cat_' + i,
              className: styles.pItem + ' ' + styles.catlist + ' ' + (active[0] === item.value ? styles.active : ''),
              onClick: function onClick() {
                return _this2.props.onClick(key, item);
              }
            },
            _react2.default.createElement(
              'a',
              { className: styles.item + ' ' + _this2.classCat(item.value) },
              _react2.default.createElement(
                'div',
                { className: styles.image },
                (0, _lib.iconCat)(item.value, active[0])
              ),
              _react2.default.createElement(
                'div',
                { className: styles.name },
                _react2.default.createElement(
                  'span',
                  null,
                  item.label
                ),
                _react2.default.createElement(
                  'span',
                  { className: styles.subName },
                  item.value === active[0] ? subs.join(', ') : ''
                )
              )
            ),
            item.icPlus && _react2.default.createElement(
              'div',
              {
                className: styles.plus,
                onClick: function onClick() {
                  return _this2.props.onPlus(item);
                }
              },
              ' ',
              '+',
              ' '
            )
          );
        })
      );
    }
  }]);
  return SelectCategory;
}(_react.Component), _class.propTypes = {
  className: _react.PropTypes.string,
  cat: _react.PropTypes.object,
  sub: _react.PropTypes.object,
  active: _react.PropTypes.array,
  subActive: _react.PropTypes.array,
  onClick: _react.PropTypes.func,
  onPlus: _react.PropTypes.func
}, _temp);

SelectCategory.defaultProps = {
  data: {},
  active: [],
  className: ''
  // onClick: function(){},
};
exports.default = SelectCategory;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/CategoryMobile/SelectCategory.js
// module id = 1546
// module chunks = 0